var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('o-confirmation-view',{attrs:{"image":"images/velo-header.jpg","message":"Je bestelling is met succes geregistreerd. Je abonnement zal beschikbaar zijn van zodra de verwerking klaar is.","nav-bar-title":"Velo jaarkaart"}})}
var staticRenderFns = []

export { render, staticRenderFns }